import identity from 'transmute/identity';
// @ts-expect-error: No type
import { createAction } from 'flux-actions';
import { checkForAuth } from '../api/HubSpotAuthApi';
import ViewerRecord, { UUID } from '../records/ViewerRecord';
import { VIEWER_ACTION_TYPES } from '../constants/ActionTypes';
import * as ViewerCache from '../utils/ViewerCache';
const {
  VIEWER_IDENTIFIED,
  VIEWER_FINISHED,
  VIEWER_IDENTIFIED_CHIRP,
  VIEWER_FINISH_SESSION_CHIRP
} = VIEWER_ACTION_TYPES;
const createIdentifyAction = createAction(VIEWER_IDENTIFIED, identity);
const createFinishedAction = createAction(VIEWER_FINISHED, identity);
const createIdentifyCHIRPAction = createAction(VIEWER_IDENTIFIED_CHIRP, identity);
const createFinishSessionCHIRPAction = createAction(VIEWER_FINISH_SESSION_CHIRP, identity);
const createEmptyViewer = () => ({
  uuid: UUID()
});
export const identifyViewer = (presentation, viewerInfo) => (dispatch, getState) => {
  const {
    legalConsent,
    legalConsentFailed
  } = getState().legalConsent;
  const cachedViewer = ViewerRecord.getFromCache();
  if (legalConsentFailed) {
    dispatch(createIdentifyAction(ViewerRecord.createEmpty()));
    return;
  }
  if (legalConsent && legalConsent.deckLegalConsentEnabled) {
    if (cachedViewer && ViewerRecord.hasEmail(cachedViewer)) {
      dispatch(createIdentifyAction(cachedViewer));
      return;
    }

    // if data privacy is on and viewerInfo is not defined yet, don't record the viewer
    if (!presentation.skipForm && !viewerInfo) {
      return;
    }
    dispatch(createIdentifyAction(ViewerRecord.create(viewerInfo)));
    return;
  }
  checkForAuth().then(auth => {
    const authViewer = ViewerRecord.createFromAuth(auth);
    if (cachedViewer && ViewerRecord.equals(cachedViewer, authViewer)) {
      dispatch(createIdentifyAction(cachedViewer));
      return;
    }
    dispatch(createIdentifyAction(authViewer));
    return;
  }, () => {
    if (cachedViewer && ViewerRecord.hasEmail(cachedViewer)) {
      dispatch(createIdentifyAction(cachedViewer));
      return;
    }
    if (presentation.skipForm) {
      if (cachedViewer) {
        dispatch(createIdentifyAction(cachedViewer));
        return;
      }
      dispatch(createIdentifyAction(ViewerRecord.createEmpty()));
      return;
    }
    if (!presentation.hasActivity) {
      dispatch(createIdentifyAction(ViewerRecord.create({
        vid: presentation.sharedWithVid
      })));
      return;
    }

    // if email is required and viewerInfo is not defined yet, don't record the viewer
    if (!presentation.skipForm && !viewerInfo) {
      return;
    }
    dispatch(createIdentifyAction(ViewerRecord.create(viewerInfo)));
  }).catch(err => {
    setTimeout(() => {
      throw err;
    });
  });
};
export const identifySharedLinkViewer = (sharedLink, viewerInfo) => (dispatch, getState) => {
  const {
    legalConsent,
    legalConsentFailed
  } = getState().legalConsent;
  const newViewer = createEmptyViewer();
  const cachedViewer = ViewerCache.get();
  if (legalConsentFailed) {
    dispatch(createIdentifyCHIRPAction(newViewer));
    return;
  }
  if (legalConsent && legalConsent.deckLegalConsentEnabled) {
    var _cachedViewer$email;
    if ((cachedViewer === null || cachedViewer === void 0 || (_cachedViewer$email = cachedViewer.email) === null || _cachedViewer$email === void 0 ? void 0 : _cachedViewer$email.length) > 0) {
      dispatch(createIdentifyCHIRPAction(cachedViewer));
      return;
    }
    if (!sharedLink.skipForm && !viewerInfo) {
      return;
    }
    dispatch(createIdentifyCHIRPAction(Object.assign({}, newViewer, {
      email: viewerInfo === null || viewerInfo === void 0 ? void 0 : viewerInfo.email
    })));
    return;
  }
  checkForAuth().then(auth => {
    const authViewer = Object.assign({}, newViewer, {
      email: auth.user.email
    });
    if (cachedViewer && cachedViewer.email === authViewer.email && cachedViewer.uuid === authViewer.uuid) {
      dispatch(createIdentifyCHIRPAction(cachedViewer));
      return;
    }
    dispatch(createIdentifyCHIRPAction(authViewer));
    return;
  }, () => {
    var _cachedViewer$email2;
    if ((cachedViewer === null || cachedViewer === void 0 || (_cachedViewer$email2 = cachedViewer.email) === null || _cachedViewer$email2 === void 0 ? void 0 : _cachedViewer$email2.length) > 0) {
      dispatch(createIdentifyCHIRPAction(cachedViewer));
      return;
    }
    if (sharedLink.skipForm) {
      if (cachedViewer) {
        dispatch(createIdentifyCHIRPAction(cachedViewer));
        return;
      }
      dispatch(createIdentifyCHIRPAction(newViewer));
      return;
    }
    if (!sharedLink.hasActivity) {
      dispatch(createIdentifyCHIRPAction(Object.assign({}, newViewer, {
        viewerId: sharedLink.sharedWithViewerId,
        email: sharedLink.sharedWithEmail
      })));
      return;
    }
    if (!sharedLink.skipForm && !viewerInfo) {
      return;
    }
    dispatch(createIdentifyCHIRPAction(Object.assign({}, newViewer, {
      email: viewerInfo === null || viewerInfo === void 0 ? void 0 : viewerInfo.email
    })));
  }).catch(err => {
    setTimeout(() => {
      throw err;
    });
  });
};
export const finishActivity = () => dispatch => {
  dispatch(createFinishedAction());
};
export const finishSessionCHIRP = ({
  pageNumber
}) => dispatch => {
  dispatch(createFinishSessionCHIRPAction({
    pageNumber
  }));
};